/* import __COLOCATED_TEMPLATE__ from './tue-iout.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();